import { Options } from 'shared/types/option';

export enum Roles {
  admin = 'ROLE_TOURNAMENT_ADMIN',
  super_admin = 'ROLE_ADMIN',
  user = 'ROLE_USER',
}

export const ROLES_OPTIONS: Options<Roles> = [
  {
    value: Roles.admin,
    label: 'Админ',
  },
];
